import ConfigurationEnum from '@/utilities/service/enums/ConfigurationEnum'

class Configuration {
  static config(): typeof ConfigurationEnum {
    return Object(ConfigurationEnum)
  }

  static value(name: keyof typeof ConfigurationEnum) {
    const config = this.config()

    if (!(name in config)) {
      return
    }

    const value = config[name]

    if (value.startsWith('VUE_APP_')) {
      return process.env[value] as string | undefined
    }

    return value
  }
}

export default Configuration
